import React, { useContext } from 'react'
import { Link, LinkGetProps } from '@reach/router'

type NavigationContextType = {
    onNavigationChange: (route: string) => void
}

export const NavigationContext = React.createContext<NavigationContextType>({
    onNavigationChange: () => console.warn('No matching context provider found'),
})

type LinkProps = {
    children: any
    to: string
    className?: string
    getProps?: (props: LinkGetProps) => {}
}

export const isExternalLink = (link: string) => /^https?:\/\/.+|\/dashboard|\/faq/.test(link)

const ContextLink = ({ children, to, className, getProps }: LinkProps) => {
    const { onNavigationChange } = useContext(NavigationContext)

    // Use Reach Router Link for internal links, and <a> for others
    if (isExternalLink(to)) {
        return (
            <a href={to} className={className}>
                {children}
            </a>
        )
    }

    return (
        <Link to={to} className={className} getProps={getProps} onClick={() => onNavigationChange(to)}>
            {children}
        </Link>
    )
}

export default ContextLink
